module.exports = __webpack_public_path__ + "img/clock-normal-red.f3a7449b.svg";